const SEPARATOR = ":";
export function buildPartRetryCountMapKey({ transferId, fileId, partId }) {
    return `${transferId}${SEPARATOR}${fileId}${SEPARATOR}${partId}`;
}
